// extracted by mini-css-extract-plugin
export default {"roleModal":"styles-module__roleModal__src-labstep-web-components-EntityUserRole-EditModal-_sH237"};